import React from 'react'
import Navbar from '../navbar'
import AboutUs from '../AboutUs'
import Footer from '../Footer'

function About() {
  return (
    <>
   <Navbar/>
   <AboutUs/>
   <Footer/>
    </>
  )
}

export default About